import { useEffect, useRef } from "react";

const getClipboardFiles = (event) => {
  const clipboardData = event.clipboardData;
  if (!clipboardData) {
    return [];
  }

  const itemFiles = Array.from(clipboardData.items || [])
    .filter((item) => item.kind === "file")
    .map((item) => item.getAsFile())
    .filter(Boolean);

  if (itemFiles.length > 0) {
    return itemFiles;
  }

  return Array.from(clipboardData.files || []);
};

const getImageClipboardFiles = (event) =>
  getClipboardFiles(event).filter((file) => file.type?.startsWith("image/"));

export const usePasteFilesOnHover = ({ enabled = true, onFiles }) => {
  const isHoveredRef = useRef(false);
  const onFilesRef = useRef(onFiles);

  useEffect(() => {
    onFilesRef.current = onFiles;
  }, [onFiles]);

  useEffect(() => {
    const handlePaste = (event) => {
      if (!enabled || !isHoveredRef.current) {
        return;
      }

      const imageFiles = getImageClipboardFiles(event);
      if (imageFiles.length === 0) {
        return;
      }

      event.preventDefault();
      onFilesRef.current?.(imageFiles, event);
    };

    window.addEventListener("paste", handlePaste);
    return () => {
      window.removeEventListener("paste", handlePaste);
    };
  }, [enabled]);

  return {
    onMouseEnter: () => {
      isHoveredRef.current = true;
    },
    onMouseLeave: () => {
      isHoveredRef.current = false;
    },
  };
};

export default usePasteFilesOnHover;
